import Utils from "../utils/Utils";

const HomeSliderController = {
  getSlider: () => {
    return Utils.controller(
      "api/homepage-slider/v1/get",
      "",
      "GET",
      "",
      false,
      "",
      true,
    );
  },
  editSlider: ({ Authorization, request }) => {
    return Utils.controller(
      "api/homepage-slider/v1/edit",
      request,
      "PUT",
      "",
      true,
      Authorization,
      true,
    );
  },
  deleteSlider: ({ Authorization, request }) => {
    return Utils.controller(
      "api/homepage-slider/v1/delete",
      request,
      "DELETE",
      "",
      true,
      Authorization,
      true,
    );
  },
  addSlider: ({ Authorization, request }) => {
    return Utils.controller(
      "api/homepage-slider/v1/add",
      request,
      "POST",
      "",
      true,
      Authorization,
      true,
    );
  },
};

export default HomeSliderController;
